/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import InternalHost from '../InternalHost';

/**
 * Host class with overrides for Illustrator
 */
class IllustratorHost extends InternalHost {
  /**
   * Constructor
   * @param {Object} initialState - initial state for component
   */
  constructor(initialState, ...args) {
    const state = {
      appName: 'Illustrator',
      eventCategory: 'Desktop',
      ...initialState
    };

    super(state, ...args);

    require('../../styles/illustratorInternal.scss');
  }

  /**
   * Checks if Illustrator is the host.
   * @param {String} appName - Application name
   * @returns {boolean} - returns boolean if in correct env.
   */
  static check(appName) {
    return appName.toLowerCase() === 'illustrator';
  }
}

export default IllustratorHost;
